import { render, staticRenderFns } from "./PlazosImpagadosStats.vue?vue&type=template&id=1def517d"
import script from "./PlazosImpagadosStats.vue?vue&type=script&setup=true&lang=js"
export * from "./PlazosImpagadosStats.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports